import React, { useMemo, createContext, useContext } from 'react';
export type BuilderConfig = {
  id: string;
  name: string;
  slug: string;
  logo?: string;
  primaryColor?: string;
  status: 'Active' | 'Trial' | 'Inactive';
};
// Builder configurations - in production this would come from an API
export const buildersConfig: Record<string, BuilderConfig> = {
  mattamy: {
    id: '3',
    name: 'Mattamy Homes',
    slug: 'mattamy',
    primaryColor: '#06b6d4',
    status: 'Active'
  },
  brookfield: {
    id: '7',
    name: 'Brookfield',
    slug: 'brookfield',
    primaryColor: '#2563eb',
    status: 'Active'
  },
  excel: {
    id: '1',
    name: 'Excel Homes',
    slug: 'excel',
    primaryColor: '#059669',
    status: 'Active'
  },
  schell: {
    id: '2',
    name: 'Schell Brothers',
    slug: 'schell',
    primaryColor: '#7c3aed',
    status: 'Active'
  },
  landmark: {
    id: '4',
    name: 'Landmark Homes',
    slug: 'landmark',
    primaryColor: '#ea580c',
    status: 'Trial'
  },
  starward: {
    id: '5',
    name: 'Starward Homes',
    slug: 'starward',
    primaryColor: '#0891b2',
    status: 'Active'
  }
};
type BuilderContextType = {
  builder: BuilderConfig | null;
  builderId: string | null;
  isValidBuilder: boolean;
};
const BuilderContext = createContext<BuilderContextType>({
  builder: null,
  builderId: null,
  isValidBuilder: false
});
export function BuilderProvider({
  builderId,
  children
}: {
  builderId: string | null;
  children: React.ReactNode;
}) {
  const value = useMemo(() => {
    if (!builderId) {
      return {
        builder: null,
        builderId: null,
        isValidBuilder: false
      };
    }
    const builder = buildersConfig[builderId.toLowerCase()];
    return {
      builder: builder || null,
      builderId,
      isValidBuilder: !!builder
    };
  }, [builderId]);
  return <BuilderContext.Provider value={value} data-id="element-153">{children}</BuilderContext.Provider>;
}
export function useBuilder() {
  return useContext(BuilderContext);
}
// Helper to get builder by numeric ID (for admin pages)
export function getBuilderByNumericId(id: string): BuilderConfig | undefined {
  return Object.values(buildersConfig).find(b => b.id === id);
}
// Helper to check if slug is available
export function isSlugAvailable(slug: string, excludeId?: string): boolean {
  const existing = buildersConfig[slug.toLowerCase()];
  if (!existing) return true;
  return existing.id === excludeId;
}